import * as z from "zod";

export const generateCopilotResponse = {
  name: "generateCopilotResponse" as const,
  input: z.object({
    conversationId: z.string(),
    prevMessageId: z.string(),
    overwrite: z.boolean().optional(),
  }),
  output: z.object({ text: z.string() }),
};
